import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initProductTabScript = () => {
  const section = document.querySelector('.product-tab');
  if (!section) return;

  const tabLinks = section.querySelectorAll('.product-tab__tab-link');
  const tabContents = section.querySelectorAll('.product-tab__tab-content');

  const slides = section.querySelectorAll('.product-tab__slide');
  slides?.forEach((slide) => {
    slide.classList.remove('lg:max-w-[328px]');
  });
  const glider = section.querySelector('.glider');

  function moveGlider(activeBtn) {
    const { offsetLeft, offsetWidth } = activeBtn;
    glider.style.transform = `translateX(${offsetLeft}px)`;
    glider.style.width = `${offsetWidth}px`;
  }

  // init position
  const firstActive = section.querySelector('.product-tab__tab-link.active');
  if (firstActive) moveGlider(firstActive);

  tabLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      const tabId = this.dataset.tab;

      // switch active
      tabLinks.forEach((l) => l.classList.remove('active', '!font-bold'));
      this.classList.add('active', '!font-bold');

      // move glider
      moveGlider(this);

      // switch content
      tabContents.forEach((c) => {
        c.classList.remove('block', 'active');
        c.classList.add('hidden');
      });
      const activeContent = document.getElementById(
        'product-tab__tab-' + tabId,
      );
      activeContent.classList.remove('hidden');
      activeContent.classList.add('block', 'active');
    });
  });

  // Swiper
  new Swiper('.product-tab__tab-content', {
    slidesPerView: 'auto',
    spaceBetween: 12,
    loop: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.product-tab--next.swiper-button-next',
      prevEl: '.product-tab--prev.swiper-button-prev',
      disabledClass: 'pointer-events-none opacity-30',
    },
    breakpoints: {
      375: { slidesPerView: 1.5, spaceBetween: 16 },
      768: { slidesPerView: 2.3, spaceBetween: 20 },
      1024: { slidesPerView: 2.6, spaceBetween: 24 },
      1536: { slidesPerView: 4, spaceBetween: 32 },
    },
  });

  const productCards = document.querySelectorAll(
    '.product-tab__slide .product-card, .product-tab__slide a',
  );

  productCards?.forEach((card) => {
    card.setAttribute('tabindex', '0');

    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        if (card.tagName.toLowerCase() === 'a' && card.href) {
          window.open(card.href, '_self');
          return;
        }

        const link = card.querySelector('a');
        if (link && link.href) {
          window.open(link.href, '_self');
        }
      }
    });
  });
};
